import {
  apiCallWithAuthWithReturn,
  handleResponseErrorData,
} from "../../clinic/utils/commonUtils";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getToken = () => {
  return localStorage.getItem("token");
};

export const serviceFetchPatientDetails = async (patientId) => {
  try {
    const url = `${API_BASE_URL}/auth/getPatientUsingPatientId`;
    const data = JSON.stringify({ patientId: patientId });
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      { "Content-Type": "application/json" },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceFetchCommonSymptoms = async () => {
  try {
    const url = `${API_BASE_URL}/api/common-symptoms`;
    return await apiCallWithAuthWithReturn(url, "GET", null, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceFetchDoctorsCustomSymptoms = async (doctorId) => {
  try {
    const url = `${API_BASE_URL}/api/doctors/${doctorId}/symptoms`;
    return await apiCallWithAuthWithReturn(url, "GET", null, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceAddCustomSymptomForDoctor = async (doctorId, symptom) => {
  try {
    const url = `${API_BASE_URL}/api/doctors/${doctorId}/symptoms/add`;
    const data = JSON.stringify(symptom);
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceFetchCommonInvestigations = async () => {
  try {
    const url = `${API_BASE_URL}/api/investigations/common`;
    return await apiCallWithAuthWithReturn(url, "GET", null, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Fetch doctor's custom lab tests
export const serviceFetchDoctorsCustomInvestigations = async (doctorId) => {
  try {
    const url = `${API_BASE_URL}/api/doctors/${doctorId}/investigations`;
    return await apiCallWithAuthWithReturn(url, "GET", null, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Add a new custom lab test for a doctor
export const serviceAddCustomInvestigationForDoctor = async (
  doctorId,
  investigation
) => {
  try {
    const url = `${API_BASE_URL}/api/doctors/${doctorId}/investigations/add`;
    const data = JSON.stringify(investigation);
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Add this function to your api.js file
export const serviceFetchDoctorsList = async (clinicId) => {
  try {
    const url = `${API_BASE_URL}/auth/fetchDoctorsWithClinicId?clinic_id=${clinicId}`;
    return await apiCallWithAuthWithReturn(url, "GET", null, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// In your API service file
export const serviceSendInvoiceToBackend = async (invoiceDetails) => {
  try {
    const url = `${API_BASE_URL}/invoices/sendInvoiceData`;
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      invoiceDetails,
      {},
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceSendPrescriptionDataToBackend = async (
  prescriptionData
) => {
  try {
    const url = `${API_BASE_URL}/prescription/sendPrescriptionData`;
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      prescriptionData,
      {},
      null,
      { removeContentType: true }
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceFetchMedicineSuggestions = async (searchTerm) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/prescription/medicines/suggestions?searchTerm=${searchTerm}`;
    const response = await apiCallWithAuthWithReturn(
      url,
      "GET",
      null,
      {},
      null
    );
    if (response?.status) {
      return (response?.data || []).map((suggestion) => ({
        label: suggestion.label,
        value: suggestion.value,
        other: { ...suggestion },
      }));
    } else {
      throw response;
    }
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceFetchDoctorDetails = async (doctorId) => {
  try {
    const url = `${API_BASE_URL}/auth/getDoctorDetails?doctor_id=${doctorId}`;
    const response = await apiCallWithAuthWithReturn(
      url,
      "GET",
      null,
      {},
      null
    );
    if (response?.status) {
      return response;
    } else {
      throw response;
    }
  } catch (error) {
    throw error;
  }
};

export const serviceFetchSuggestions = async (value, clinicId) => {
  try {
    const url = `${API_BASE_URL}/prescription/autocomplete?searchTerm=${value}&clinicId=${clinicId}`;
    return await apiCallWithAuthWithReturn(url, "GET", null, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const generatePrescriptionDataUsingAudio = async (prescriptionData) => {
  try {
    const url = `${API_BASE_URL}/prescription/generatePrescriptionDataUsingAudio`;
    const data = prescriptionData;
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null, {
      removeContentType: true,
    });
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceSendPrescriptionDataToWhatsapp = async (
  prescriptionData
) => {
  const data = JSON.stringify(prescriptionData);
  try {
    const url = `${API_BASE_URL}/prescription/sendPrescriptiontoWhatsapp`;
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      { "Content-Type": "application/json" },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceSuggestLabTests = async (complaints) => {
  const data = JSON.stringify({ complaints });
  try {
    const url = `${API_BASE_URL}/prescription/suggestLabTests`;
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      { "Content-Type": "application/json" },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};
